export var RegistrationReason = /*#__PURE__*/function (RegistrationReason) {
  RegistrationReason["careDegree"] = "careDegree";
  RegistrationReason["careDegreePending"] = "careDegreePending";
  RegistrationReason["practiceVolunteerWork"] = "practiceVolunteerWork";
  RegistrationReason["generalAndPrevention"] = "generalAndPrevention";
  RegistrationReason["other"] = "other";
  return RegistrationReason;
}(RegistrationReason || {});